export default {
	id: 'SIMPLE_PREMIUM_MALE_FALLBACK_MW_ROW_4W_44_4W_7_99',
	providers: {
		paltaMap: {
			USD: 'simple_premium_4w_44_4w_7_99_usd',
			EUR: 'simple_premium_4w_39_4w_7_99_eur',
			GBP: 'simple_premium_4w_29_99_4w_14_39_gbp',
			AUD: 'simple_premium_4w_49_99_4w_21_59_aud',
			CAD: 'simple_premium_4w_49_99_4w_21_59_cad',
			DKK: 'simple_premium_4w_259_4w_103_2_dkk',
			SEK: 'simple_premium_4w_399_4w_159_2_sek',
			NOK: 'simple_premium_4w_399_4w_159_2_nok',
			BRL: 'simple_premium_4w_99_4w_31_2_brl',
			MXN: 'simple_premium_4w_499_4w_239_2_mxn',
			TRY: 'simple_premium_4w_999_4w_479_2_try',
			ARS: 'simple_premium_4w_39990_4w_19192_ars',
			COP: 'simple_premium_4w_119990_4w_58312_cop',
			CLP: 'simple_premium_4w_29990_4w_13992_clp',
		},
		primer: 'prd_y5bxOUX3EbkY',
	},
}
